import logo from './logo.webp'

export default function Logo() {
  return (
    <img
      src={logo}
      alt="Logo"
      width="63"
      height="57"
      style={{ display: 'block' }}
    />
  )
}
